<template>
  <aside class="the-sidebar">
    <div class="the-sidebar-logo">
      <span>
        <img 
          @click="$router.push('/dashboard')"
          src="@/assets/images/nextshop-logo.svg" 
          alt="nextshop_logo"
      ></span>
    </div>
    <div class="the-sidebar-main">
      <ul>
        <SidebarItem
          :data="item"
          v-for="(item, index) in menuItems"
          :key="index"
          @getID="getId($event)"
        />
      </ul>
      <ul class="item-pinned">
        <SidebarFooterItem
          :data="item"
          v-for="(item, index) in menuFooterItems"
          :key="index"
        />
      </ul>
    </div>
  </aside>
</template>

<script>
import { mapGetters } from "vuex";
import { menuFooterItems2 } from "@/components/menu";
import SidebarItem from "./components/sidebar-item.vue";
import SidebarFooterItem from "./components/sidebar-footer-item.vue"

export default {
  components: {
    SidebarItem,
    SidebarFooterItem,
  },

  data() {
    return {
      menuItems: [],
      menuFooterItems: menuFooterItems2,
    };
  },
  created() {
    const routes = this.$router.options.routes.filter(route => !route.hidden)
    const sidebar = routes.map((route, index) => {
      // if (route.meta?.title) {
      //   return {
      //     id: index,
      //     icon: route.meta.icon,
      //     label: route.meta.title, //required
      //     href: route.href, //required
      //     link: route.path,
      //     listPermission: route.listPermission, //required
      //     ssOpen: false
      //   }
      // } else 
      if (route.children && route.children.filter(chil=> !chil.hidden).length === 1) {
        return {
          id: index,
          icon: route.meta.icon,
          label: route.meta.title,
          href: route.href,
          link: route.path,
          listPermission: route.listPermission,
          isOpen: false
        }
      } else if (route.children && route.children.filter(chil=> !chil.hidden).length > 1) {
        return {
          id: index,
          icon: route.meta.icon,
          label: route.meta.title,
          link: route.path,
          listPermission: route.listPermission,
          isOpen: false,
          subItems: route.children.filter(c => !c.hidden).map((children, index2) => {
            const checkPath = children.path[0] === '/'
            return {
              id: index2,
              label: children.meta.title,
              link: checkPath ? children.path : route.path + '/' + children.path,
              parentId: index,
              permission: children.permission,
            }
          })
        }
      }
    }).filter(route => route)
    this.menuItems = sidebar
  },
  methods: {
    getId(id) {
      const sidebar = this.menuItems.find((e) => e.id == id)
      if (sidebar.isOpen == true) {
        sidebar.isOpen = false
        return
      }
      this.menuItems.forEach(e => e.isOpen = false)
      sidebar.isOpen = !sidebar.isOpen
    }
  },

  computed: {
    ...mapGetters("sidebar", ["getMenuSideBar"]),
  },

};
</script>

<style lang="scss" scoped>

.the-sidebar {
  height: calc(100vh);
  background: white;
  // height: auto;
  border-left: 1px solid #ddd;
  display: flex;
  flex-direction: column;
  &-logo {
    flex: 0 0 64px;
    background: white;
    // border-bottom: 1px solid #ddd;
    box-shadow: inset 0px -1px 0px #DDDDDD;

    span {
      display: block;
      text-align: center;
      padding: 15px 0;
    }

    img {
      cursor: pointer;
    }
  }

  &-main {
    flex: 1 1 0%;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
      background: rgb(184, 184, 184);
      max-height: 50px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: rgb(163, 163, 163);
    }

    ul.item-pinned {
      border-top: 1px solid #ddd;
    }
  }

  &-pinned {
    flex: 0 0 auto;
    border-top: 1px solid #ddd;
    ul {
      margin-bottom: 0;
      li {
        span {
          place-items: center;
          color: #000;
          font-weight: 500;

          &:nth-child(2) {
            margin-left: 12px;
          }
        }
      }
    }
  }
}


</style>